<template>
  <div>
    <!--Header-->
    <div class="header pb-6 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-default opacity-8"></span>
    </div>
    <section class="section section-lg pt-4 pb-2 bg-white">
      <b-container>
        <h3 class="mb-0" v-if="podcast">{{ podcast.title }}</h3>
        <p class="small">Welcome to our podcast, Go Time with Zuber.</p>
        <b-row class="justify-content-center">
          <b-col md="3" v-if="owner || agent" class="text-center">
            <b-button block size="lg" variant="outline-danger" @click="goToDashboard" class="mb-2">
              <div class="mb-2">
                <i class="fas fa-2x fa-tachometer-alt text-black"></i>
              </div>
              Portal Dashboard
            </b-button>
          </b-col>
          <b-col md="3" class="text-center">
            <b-button block size="lg" variant="outline-danger" :to="'/observatory'" class="mb-2">
              <div class="mb-2">
                <i class="fas fa-2x fa-eye text-black"></i>
              </div>
              Observatory
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="section section-lg mt-5">
      <b-container>
        <b-row v-if="podcast">
          <b-col md="4" v-for="(episode, index) in podcast.episodes" :key="index">
            <b-card :title="episode.title">
              <b-card-text><span v-html="episode.description"></span></b-card-text>
              <a :href="episode.permalink" target="_blank"><strong>Watch Now <i class="fas fa-angle-right"></i></strong></a>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  data() {
    return {
      podcast: null
    }
  },
  computed: {
    roles() {
      return this.$store.getters['roles/roles'];
    },
    owner() {
      return this.roles.includes('owner');
    },
    agent() {
      return this.roles.includes('agent');
    },
  },
  methods: {
    async getPodcast() {
      axios.get(process.env.VUE_APP_API_BASE_URL + "/podcast")
      .then(response => {
        this.podcast = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async goToDashboard() {
      await this.$router.push({ path: "/dashboard" });
    }
  },
  created() {
    this.getPodcast();
  }
};
</script>